export const SearchLoading = () => (
  <div className="bg-base-80 text-base-30 h-screen flex flex-col items-center justify-center gap-4">
    <p className="text-m-r">Loading chats…</p>
  </div>
);
